const RECEPTACLE_TITLE = 'Receptacles';

export const getReceptacleListTitle = (param = '', suffix = '') => {
  switch (param) {
  case 'pending': {
    return `Pending ${RECEPTACLE_TITLE} ${suffix}`;
  }
  case 'approved': {
    return `Approved ${RECEPTACLE_TITLE} ${suffix}`;
  }
  case 'disapproved': {
    return `Disapproved ${RECEPTACLE_TITLE} ${suffix}`;
  }
  case 'failed': {
    return `Discrepancy ${RECEPTACLE_TITLE} ${suffix}`;
  }
  default:
    return `All ${RECEPTACLE_TITLE} ${suffix}`;
  }
};
